// extracted by mini-css-extract-plugin
module.exports = {"titleWrapper":"style_titleWrapper__2vN7N","rowsWrapper":"style_rowsWrapper__2qGdL","rowWrapper":"style_rowWrapper__23bx-"};